export default {
  name: {
    presence: { allowEmpty: false }
  },
  isPublic: {
    presence: { allowEmpty: false }
  }
};
